
import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ExpertiseSection } from './components/ExpertiseSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from '../../components/feature/Footer';
import { Header } from '../../components/feature/Header';
import { ServicesCarousel } from '../../components/feature/ServicesCarousel';
import { CustomerBrandsCarousel } from './components/CustomerBrandsCarousel';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesCarousel />
      <ServicesSection />
      <ExpertiseSection />
      <CustomerBrandsCarousel />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
